/* components/Subscription.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	text,
	toggle_class
} from "svelte/internal";

import jsonp from "jsonp";

function add_css() {
	var style = element("style");
	style.id = "svelte-1fwipkv-style";
	style.textContent = "form.svelte-1fwipkv{display:flex;flex-direction:column;margin-top:20px}input.svelte-1fwipkv{width:100%;height:52px;border:1px solid #29ABE2;box-sizing:border-box;font-family:inherit;color:inherit;background:transparent;padding:0 16px;font-size:16px;outline:none}input.svelte-1fwipkv::placeholder{color:white}.block.svelte-1fwipkv{position:relative;flex:1 0 0}.error.svelte-1fwipkv{width:100%;background:#FF4A4A;color:#fff;opacity:0;line-height:1.7;font-size:12px;font-weight:600;padding:0 5px;box-sizing:border-box;display:inline-block;transition:.15s ease-out;transform:translate3d(0px, -3px, 0)}.success.svelte-1fwipkv{width:100%;background:#12BD75;color:#fff;line-height:1.7;font-size:12px;font-weight:600;padding:0 5px;box-sizing:border-box;display:inline-block;transition:.15s ease-out;transform:translate3d(0px, -3px, 0)}.show.svelte-1fwipkv{opacity:1}button.svelte-1fwipkv:disabled{opacity:0.2;cursor:not-allowed}@media screen and (min-width: 600px){form.svelte-1fwipkv{flex-direction:row}button.svelte-1fwipkv{margin-left:16px}}";
	append(document.head, style);
}

// (14:2) {:else}
function create_else_block(ctx) {
	let span;

	return {
		c() {
			span = element("span");
			span.textContent = "Invalid email address";
			attr(span, "class", "error svelte-1fwipkv");
			toggle_class(span, "show", /*error*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*error*/ 2) {
				toggle_class(span, "show", /*error*/ ctx[1]);
			}
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (10:2) {#if success}
function create_if_block(ctx) {
	let span;

	return {
		c() {
			span = element("span");
			span.textContent = "Thanks for your subscription!";
			attr(span, "class", "success svelte-1fwipkv");
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

function create_fragment(ctx) {
	let form;
	let div;
	let input;
	let t0;
	let t1;
	let button;
	let t2;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*success*/ ctx[2]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			form = element("form");
			div = element("div");
			input = element("input");
			t0 = space();
			if_block.c();
			t1 = space();
			button = element("button");
			t2 = text("sign up");
			attr(input, "type", "text");
			attr(input, "autocomplete", "off");
			attr(input, "placeholder", "Your email address");
			attr(input, "class", "svelte-1fwipkv");
			attr(div, "class", "block svelte-1fwipkv");
			attr(button, "class", "button svelte-1fwipkv");
			button.disabled = /*success*/ ctx[2];
			attr(form, "class", "svelte-1fwipkv");
		},
		m(target, anchor) {
			insert(target, form, anchor);
			append(form, div);
			append(div, input);
			set_input_value(input, /*email*/ ctx[0]);
			append(div, t0);
			if_block.m(div, null);
			append(form, t1);
			append(form, button);
			append(button, t2);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[4]),
					listen(input, "focus", /*focus_handler*/ ctx[5]),
					listen(form, "submit", prevent_default(/*onSubmit*/ ctx[3]))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*email*/ 1 && input.value !== /*email*/ ctx[0]) {
				set_input_value(input, /*email*/ ctx[0]);
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}

			if (dirty & /*success*/ 4) {
				button.disabled = /*success*/ ctx[2];
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(form);
			if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

const url = "https://cointelegraph.us3.list-manage.com/subscribe/post-json?u=2c088712615955cd2f82aa968";
const id = "ae5eda079d";

function emailValidator(value) {
	return value && !!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) || false;
}

function instance($$self, $$props, $$invalidate) {
	let email = "";
	let error;
	let success = false;

	const onSubmit = event => {
		event.preventDefault();
		const valid = emailValidator(email);

		if (!valid) {
			$$invalidate(1, error = true);
			return;
		}

		if (email && valid) {
			$$invalidate(2, success = true);
			$$invalidate(0, email = "");
			sendData();

			setTimeout(
				function () {
					$$invalidate(2, success = false);
				},
				3000
			);
		}
	};

	const sendData = () => {
		return new Promise(resolve => {
				const query = `${url}&id=${id}&EMAIL=${email}`;

				const response = {
					error: false,
					message: "",
					hasStopPhrases: false
				};

				jsonp(query, { param: "c" }, (err, { msg, result } = {}) => {
					resolve({
						...response,
						error: err || result === "error",
						message: msg
					});
				});
			});
	};

	function input_input_handler() {
		email = this.value;
		$$invalidate(0, email);
	}

	const focus_handler = () => $$invalidate(1, error = null);
	return [email, error, success, onSubmit, input_input_handler, focus_handler];
}

class Subscription extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1fwipkv-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Subscription;